import { Component, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { User } from 'src/app/model/user.model';

import { ModalPopupService } from 'src/app/shared/services/modal-popup.service';
import { CommonApiService } from 'src/app/shared/services/common-api.service';
import { CommonErrorMessages } from 'src/app/shared/constants/app.constant';
import { TokenManagerService } from 'src/app/core/services/token-manager.service';

@Component({
  selector: 'app-user-profile',
  templateUrl: 'user-profile.component.html',
  styleUrls: ['user-profile.component.scss']
})
export class UserProfileComponent implements OnInit {
  userProfileForm: FormGroup;
  data: User;
  loading: boolean;
  result = new EventEmitter();
  message: string;
  unmask = true;

  constructor(
    private formBuilder: FormBuilder,
    private modalPopupService: ModalPopupService,
    private commonApiService: CommonApiService,
    private tokenManagerService: TokenManagerService
  ) { }

  ngOnInit(): void {
    this.userProfileForm = this.formBuilder.group({
      FirstName: [this.data?.FirstName, [Validators.required]],
      LastName: [this.data?.LastName, [Validators.required]],
      Address: [this.data?.Address, [Validators.required]],
      CityName: [this.data?.CityName, [Validators.required]],
      ProvincesName: [this.data?.ProvincesName, [Validators.required]],
      CountryName: [this.data?.CountryName, [Validators.required]],
      PostalCode: [this.data?.PostalCode, [Validators.required]],
      PhoneNo: [this.data?.PhoneNo, [Validators.required]]
    });
  }

  close(): void {
    this.modalPopupService.hideModal();
  }

  saveProfile(): void {
    this.message = '';
    if (!this.userProfileForm.valid) {
      this.userProfileForm.markAllAsTouched();
    } else {
      this.loading = true;
      this.commonApiService.updateUserProfile(this.userProfileForm.value).subscribe(
        (response) => {
          this.loading = false;
          this.setUserDetail(this.userProfileForm.value);
          this.close();
        }, (error) => {
          this.message = CommonErrorMessages.ServerError;
          this.loading = false;
        });
    }
  }

  setUserDetail(user: User): void {
    this.data.FirstName = user.FirstName;
    this.data.LastName = user.LastName;
    this.data.Address = user.Address;
    this.data.CityName = user.CityName;
    this.data.ProvincesName = user.ProvincesName;
    this.data.CountryName = user.CountryName;
    this.data.PostalCode = user.PostalCode;
    this.data.PhoneNo = user.PhoneNo;
    if (!this.data.IsAddressAdded) {
      this.data.IsAddressAdded = true;
      this.tokenManagerService.setUserDetail(this.data);
    }
    this.result.emit(this.data);
  }
}
